import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="indicacion-detalle-form"
export default class extends Controller {
  static targets = [
    "tipoIndicacion",
    "parenteralFields",
    "farmacologicaFields",
    "enteralFields",
    "nutricionFields",
    "viaAsignacionSelect",
    "viaOption",
    "tipoSelect",
    "tipoOption",
    "velocidadSelect",
    "velocidadOption",
    "cantidadLabel",
    "cantidadInput",
    "indicacionesList",
    "indicacionesJson",
    "agregadosContainer",
    "volumen",
    "unidad",
    "Intervalo",
    "tiposNutricionSelect",
    "farmacoHabitual",
    "checkbox",
    "matriculaInput"
  ]

  static values = {
    id: String
  }

  indicaciones = [];

  connect() {
    this.toggleFields();
    this.filterViaAsignacionOptions();
    this.tipoOptions();
    this.velocidadOptions();
    this.updateCantidadLabel();

    try {
      if (this.hasMatriculaInputTarget && this.matriculaInputTarget) {
        this.matriculaInputTarget.addEventListener('input', () => {
          const hidden = document.querySelector('#matriculaIndicacionModal [data-autocomplete-target="hidden"]');
          if (hidden) hidden.value = '';
        });
      }
    } catch (e) {}
  }

  openMatriculaModal(e) {
    e.preventDefault();

    if (this.indicaciones.length === 0) {
      alert("No hay indicaciones agregadas para guardar.");
      return;
    }

    $('#matriculaIndicacionModal').modal('show');
  }

  submitForm(e) {
    e.preventDefault();
    const matriculaTexto = this.hasMatriculaInputTarget ? this.matriculaInputTarget.value.trim() : ''
    const hiddenField = document.querySelector('#matriculaIndicacionModal [data-autocomplete-target="hidden"]')
    const matriculaSeleccionada = hiddenField ? (hiddenField.value || '').toString().trim() : ''

    if (matriculaTexto === '' || matriculaSeleccionada === '') {
      alert('Debes seleccionar un profesional del buscador. Escribe y elige una opción de la lista desplegable.');
      return
    }

    const form = document.getElementById(this.idValue);
    
    if (form) {
      this.indicacionesJsonTarget.value = JSON.stringify(this.indicaciones);
      form.requestSubmit();
    }

    $('#matriculaIndicacionModal').modal('hide');
  }
  
  hiddeModal(e) {
    $('#matriculaIndicacionModal').modal('hide');
  }

  toggleFields() {
    const selectedType = this.tipoIndicacionTarget.value;

    this.parenteralFieldsTargets.forEach(el => el.classList.add("d-none"));
    this.farmacologicaFieldsTargets.forEach(el => el.classList.add("d-none"));
    this.enteralFieldsTargets.forEach(el => el.classList.add("d-none"));
    this.nutricionFieldsTargets.forEach(el => el.classList.add("d-none"));

    switch (selectedType) {
      case "parenteral":
        this.parenteralFieldsTargets.forEach(el => el.classList.remove("d-none"));
        document.getElementById('farmaco-habitual').style.display = 'none';
        document.getElementById('farmaco-search').style.display = 'block';
        this.element.querySelector('[data-autocomplete-target="input"]').value = '';
        this.element.querySelector('[data-autocomplete-target="hidden"]').value = '';
        this.checkboxTarget.checked = false
        break;
        case "farmacologica":
        document.getElementById('farmaco-habitual').style.display = 'none';
        document.getElementById('farmaco-search').style.display = 'block';
        this.element.querySelector('[data-autocomplete-target="input"]').value = '';
        this.element.querySelector('[data-autocomplete-target="hidden"]').value = '';
        this.checkboxTarget.checked = false
        this.farmacologicaFieldsTargets.forEach(el => el.classList.remove("d-none"));
        break;
        case "enteral":
        document.getElementById('farmaco-habitual').style.display = 'none';
        document.getElementById('farmaco-search').style.display = 'block';
        this.element.querySelector('[data-autocomplete-target="input"]').value = '';
        this.element.querySelector('[data-autocomplete-target="hidden"]').value = '';
        this.checkboxTarget.checked = false
        this.enteralFieldsTargets.forEach(el => el.classList.remove("d-none"));
        break;
        case "nutricion":
        document.getElementById('farmaco-habitual').style.display = 'none';
        document.getElementById('farmaco-search').style.display = 'block';
        this.element.querySelector('[data-autocomplete-target="input"]').value = '';
        this.element.querySelector('[data-autocomplete-target="hidden"]').value = '';
        this.checkboxTarget.checked = false
        this.nutricionFieldsTargets.forEach(el => el.classList.remove("d-none"));
        break;
      default:
        break;
    }

    this.filterViaAsignacionOptions();
    this.tipoOptions();
    this.velocidadOptions();
    this.updateCantidadLabel();
  }

  filterViaAsignacionOptions() {
    const selectedType = this.tipoIndicacionTarget.value;
    const viaSelect = this.viaAsignacionSelectTarget;

    const currentValue = viaSelect.value;

    while (viaSelect.options.length > 0) {
      viaSelect.remove(0);
    }

    const promptOption = this.viaOptionTargets.find(option => option.dataset.isPrompt === "true");
    if (promptOption) {
      viaSelect.add(promptOption.cloneNode(true));
    }

    this.viaOptionTargets.forEach(option => {
      if (option.dataset.isPrompt === "true") {
        return;
      }

      const allowedTypes = option.dataset.allowedTypes ? option.dataset.allowedTypes.split(',') : [];

      if (allowedTypes.includes(selectedType) || allowedTypes.length === 0) {
        viaSelect.add(option.cloneNode(true));
      }
    });

    if (Array.from(viaSelect.options).some(opt => opt.value === currentValue)) {
      viaSelect.value = currentValue;
    } else {
      viaSelect.value = "";
    }
  }

  tipoOptions() {
    const selectedType = this.tipoIndicacionTarget.value;
    const tipoSelect = this.tipoSelectTarget;

    const currentValue = tipoSelect.value;

    while (tipoSelect.options.length > 0) {
      tipoSelect.remove(0);
    }

    const promptOption = this.tipoOptionTargets.find(option => option.dataset.isPrompt === "true");
    if (promptOption) {
      tipoSelect.add(promptOption.cloneNode(true));
    }

    this.tipoOptionTargets.forEach(option => {
      if (option.dataset.isPrompt === "true") {
        return;
      }

      const allowedTypes = option.dataset.allowedTypes ? option.dataset.allowedTypes.split(',') : [];

      if (allowedTypes.includes(selectedType) || allowedTypes.length === 0) {
        tipoSelect.add(option.cloneNode(true));
      }
    });

    if (Array.from(tipoSelect.options).some(opt => opt.value === currentValue)) {
      tipoSelect.value = currentValue;
    } else {
      tipoSelect.value = "";
    }
  }

  velocidadOptions() {
    const selectedType = this.tipoIndicacionTarget.value;
    const velocidadSelect = this.velocidadSelectTarget;

    const currentValue = velocidadSelect.value;

    while (velocidadSelect.options.length > 0) {
      velocidadSelect.remove(0);
    }

    const promptOption = this.velocidadOptionTargets.find(option => option.dataset.isPrompt === "true");
    if (promptOption) {
      velocidadSelect.add(promptOption.cloneNode(true));
    }

    this.velocidadOptionTargets.forEach(option => {
      if (option.dataset.isPrompt === "true") {
        return;
      }

      const allowedTypes = option.dataset.allowedTypes ? option.dataset.allowedTypes.split(',') : [];

      if (allowedTypes.includes(selectedType) || allowedTypes.length === 0) {
        velocidadSelect.add(option.cloneNode(true));
      }
    });

    if (Array.from(velocidadSelect.options).some(opt => opt.value === currentValue)) {
      velocidadSelect.value = currentValue;
    } else {
      velocidadSelect.value = "";
    }
  }

  updateCantidadLabel() {
    const selectedType = this.tipoIndicacionTarget.value;
    let newLabelText = 'Dosis/Cantidad';
    let newPlaceholderText = 'Dosis/Cantidad';

    if (selectedType === 'enteral') {
      newLabelText = 'Infusión';
      newPlaceholderText = 'Infusión';
    }

    this.cantidadLabelTarget.textContent = newLabelText;
    this.cantidadInputTarget.placeholder = newPlaceholderText;
  }

  addIndicacion() {
    const indicacionData = {
      tipo_indicacion: this.tipoIndicacionTarget.value,
      Fecha: this.element.querySelector('#indicacion-medica-detalle-fecha-input').value,
      hora: this.element.querySelector('#indicacion-medica-detalle-hora-carga-input').value,
      tipo: this.hasTipoSelectTarget ? this.tipoSelectTarget.value : '',
      MaterialNombre: this.element.querySelector('[data-autocomplete-target="input"]').value,
      MaterialCodigo: this.element.querySelector('[data-autocomplete-target="hidden"]').value,
      farmaco: this.farmacoHabitualTarget.value,
      medicacion_habitual: this.element.querySelector('#indicacion_medica_indicaciones_medicas_detalles_attributes_0_medicacion_habitual').checked,
      volumen: this.hasVolumenTarget ? this.volumenTarget.value : '',
      via_asignacion: this.hasViaAsignacionSelectTarget ? this.viaAsignacionSelectTarget.value : '',
      velocidad: this.hasVelocidadSelectTarget ? this.velocidadSelectTarget.value : '',
      unidad: this.hasUnidadTarget ? this.unidadTarget.value : '',
      Cantidad: this.hasCantidadInputTarget ? this.cantidadInputTarget.value : '',
      Intervalo: this.hasIntervaloTarget ? this.IntervaloTarget.value : '',
      Observaciones: this.element.querySelector('#indicacion_medica_indicaciones_medicas_detalles_attributes_0_Observaciones').value,
      tipos_nutricion: this.hasTiposNutricionSelectTarget ? Array.from(this.tiposNutricionSelectTarget.selectedOptions).map(option => option.text) : [],
      tipo_indicacion_medica_detalle_ids: this.hasTiposNutricionSelectTarget ? Array.from(this.tiposNutricionSelectTarget.selectedOptions).map(option => option.value) : [],
      indicacion_agregados_attributes: []
    };

    if (indicacionData.tipos_nutricion.length === 0) {
      if (!indicacionData.tipo_indicacion || !indicacionData.Fecha || !indicacionData.hora || (this.checkboxTarget.checked ? !indicacionData.farmaco : !indicacionData.MaterialCodigo)) {
        alert("Por favor, complete los campos obligatorios antes de agregar la indicación: Tipo de Indicación, Fecha, Hora y Fármaco.");
        return;
      }
    }

    if (this.hasAgregadosContainerTarget && !this.agregadosContainerTarget.classList.contains('d-none')) {
      const agregadosForms = this.agregadosContainerTarget.querySelectorAll('.agregados-custom-form-wrapper');

      agregadosForms.forEach(agregadoForm => {
        const materialAutocompleteInput = agregadoForm.querySelector('[data-autocomplete-target="input"]');
        const materialHiddenInput = agregadoForm.querySelector('[data-autocomplete-target="hidden"]');
        const cantidadInput = agregadoForm.querySelector('[id$="_cantidad"]');
        const unidadAgregadosSelect = agregadoForm.querySelector('[id$="_unidad_agregados"]');
        const destroyInput = agregadoForm.querySelector('[id$="__destroy"]');

        if (destroyInput && destroyInput.value === 'true') {
          if (agregadoForm.dataset.newRecord === 'false') {
            indicacionData.indicacion_agregados_attributes.push({
              id: materialHiddenInput.id.match(/attributes_(\d+)_/)[1],
              _destroy: true
            });
          }
          return;
        }

        if (materialHiddenInput && cantidadInput && unidadAgregadosSelect) {
          const agregado = {
            MaterialNombre: materialAutocompleteInput ? materialAutocompleteInput.value : '',
            MaterialCodigo: materialHiddenInput.value,
            cantidad: cantidadInput.value,
            unidad_agregados: unidadAgregadosSelect.value,
          };

          if (agregadoForm.dataset.newRecord === 'false') {
            const idMatch = materialHiddenInput.name.match(/\[(\d+)\]\[MaterialCodigo\]/);
            if (idMatch && idMatch[1]) {
              agregado.id = idMatch[1];
            }
          }
          indicacionData.indicacion_agregados_attributes.push(agregado);
        }
      });
    }

    this.indicaciones.push(indicacionData);
    this.renderIndicacionesList();

    this.clearForm();
  }

  renderIndicacionesList() {
    this.indicacionesListTarget.innerHTML = '';

    this.indicaciones.forEach((indicacion, index) => {
      const listItem = document.createElement('div');
      listItem.classList.add('card', 'mb-2');
      listItem.dataset.index = index;

      let agregadosHtml = '';
      if (indicacion.indicacion_agregados_attributes && indicacion.indicacion_agregados_attributes.length > 0) {
        agregadosHtml = '<strong>Agregados:</strong><br><ul>';
        indicacion.indicacion_agregados_attributes.forEach(agregado => {
          if (!agregado._destroy) {
            const nombreMostrar = agregado.MaterialNombre || agregado.MaterialCodigo;
            agregadosHtml += `<li>${nombreMostrar} - ${agregado.cantidad} ${this.translateUnidadAgregado(agregado.unidad_agregados)}</li>`;
          }
        });
        agregadosHtml += '</ul>';
      }

      let tiposNutricionHtml = '';
      if (indicacion.tipos_nutricion && indicacion.tipos_nutricion.length > 0) {
        tiposNutricionHtml = `<strong>Tipos de Nutrición:</strong> ${indicacion.tipos_nutricion.join('<strong> - </strong>')}<br>`;
      }

      listItem.innerHTML = `
        <div class="card-body d-flex justify-content-between align-items-center">
          <div class="flex-grow-1 me-3">
            <h5 class="card-title">${indicacion.MaterialNombre || indicacion.farmaco || 'Fármaco no especificado'}</h5>
            <p class="card-text">
              <strong>Tipo de Indicación</strong> ${this.translateTipoIndicacion(indicacion.tipo_indicacion)} -
              <strong>Fecha y Hora:</strong> ${indicacion.Fecha} ${indicacion.hora} -
              ${indicacion.tipo ? `<strong>Tipo:</strong> ${this.translateTipo(indicacion.tipo)} -` : ''}
              ${indicacion.volumen ? `<strong>Volumen:</strong> ${this.translateVolumen(indicacion.volumen)} -` : ''}
              ${indicacion.via_asignacion ? `<strong>Vía:</strong> ${this.translateVia(indicacion.via_asignacion)} -` : ''}
              ${indicacion.velocidad ? `<strong>Velocidad:</strong> ${this.translateVelocidad(indicacion.velocidad)} -` : ''}
              ${indicacion.Cantidad ? `<strong>Dosis/Cantidad:</strong> ${indicacion.Cantidad} ${this.translateUnidad(indicacion.unidad)} -` : ''}
              ${indicacion.Intervalo ? `<strong>Frecuencia:</strong> ${this.translateIntervalo(indicacion.Intervalo)} -` : ''}
              ${indicacion.medicacion_habitual ? `<strong>Medicación habitual:</strong> Sí<br>` : ''}
              ${indicacion.Observaciones ? `<strong>Observaciones:</strong> ${indicacion.Observaciones}<br>` : ''}
              ${indicacion.tipo_indicacion == "parenteral" ? agregadosHtml : ''}
              ${indicacion.tipo_indicacion == "nutricion" ? tiposNutricionHtml : ''}
            </p>
          </div>
          <button type="button" class="btn btn-danger ms-auto ml-2" data-action="click->indicacion-detalle-form#removeIndicacion" data-index="${index}">
            Eliminar
          </button>
        </div>
      `;
      this.indicacionesListTarget.appendChild(listItem);
    });
  }

  removeIndicacion(event) {
    const indexToRemove = parseInt(event.target.dataset.index);
    this.indicaciones.splice(indexToRemove, 1);
    this.renderIndicacionesList();
  }

  clearForm() {
    if (this.hasTipoSelectTarget) this.tipoSelectTarget.value = '';
    this.element.querySelector('[data-autocomplete-target="input"]').value = '';
    this.element.querySelector('[data-autocomplete-target="hidden"]').value = '';
    this.element.querySelector('#indicacion_medica_indicaciones_medicas_detalles_attributes_0_medicacion_habitual').checked = false;
    if (this.hasVolumenTarget) this.volumenTarget.value = '';
    if (this.hasViaAsignacionSelectTarget) this.viaAsignacionSelectTarget.value = '';
    if (this.hasVelocidadSelectTarget) this.velocidadSelectTarget.value = '';
    if (this.hasUnidadTarget) this.unidadTarget.value = '';
    if (this.hasCantidadInputTarget) this.cantidadInputTarget.value = '';
    if (this.hasIntervaloTarget) this.IntervaloTarget.value = '';
    this.element.querySelector('#indicacion_medica_indicaciones_medicas_detalles_attributes_0_Observaciones').value = '';
    if (this.hasTiposNutricionSelectTarget) {

      if (this.tiposNutricionSelectTarget.tomselect) {
        this.tiposNutricionSelectTarget.tomselect.clear();
      } else {
        this.tiposNutricionSelectTarget.value = '';
      }
    };
    if (this.farmacoHabitualTarget.value) this.farmacoHabitualTarget.value = '';

    document.getElementById('farmaco-habitual').style.display = 'none';
    document.getElementById('farmaco-search').style.display = 'block';

    if (this.hasAgregadosContainerTarget) {
      const agregadosForms = this.agregadosContainerTarget.querySelectorAll('.agregados-custom-form-wrapper');

      for (let i = 0; i < agregadosForms.length; i++) {
        const form = agregadosForms[i];
        const destroyInput = form.querySelector('[id$="__destroy"]');

        if (i === 0) {
          const materialAutocompleteInput = form.querySelector('[data-autocomplete-target="input"]');
          const materialHiddenInput = form.querySelector('[data-autocomplete-target="hidden"]');
          const cantidadInput = form.querySelector('[id$="_cantidad"]');
          const unidadSelect = form.querySelector('[id$="_unidad_agregados"]');

          if (materialAutocompleteInput) materialAutocompleteInput.value = '';
          if (materialHiddenInput) materialHiddenInput.value = '';
          if (cantidadInput) cantidadInput.value = '';
          if (unidadSelect) unidadSelect.value = '';

          if (destroyInput) {
            destroyInput.value = 'false';
          }
          form.style.display = '';
        } else {
          if (destroyInput && form.dataset.newRecord === 'false') {
            destroyInput.value = 'true';
            form.style.display = 'none';
          } else {
            form.remove();
          }
        }
      }

      if (agregadosForms.length === 0 || this.agregadosContainerTarget.querySelectorAll('.agregados-custom-form-wrapper:not([style*="display: none"])').length === 0) {
        const nestedFormController = this.application.getControllerForElementAndIdentifier(this.agregadosContainerTarget, 'nested-form');
        if (nestedFormController && typeof nestedFormController.add === 'function') {
          nestedFormController.add();
        } else {
          const template = this.agregadosContainerTarget.querySelector('template[data-nested-form-target="template"]');
          const target = this.agregadosContainerTarget.querySelector('[data-nested-form-target="target"]');
          if (template && target) {
            let content = template.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
            target.insertAdjacentHTML('beforeend', content);
          }
        }
      }
    }

    this.toggleFields();
  }

  saveIndicaciones(event) {
    if (this.indicaciones.length === 0) {
      alert("No hay indicaciones agregadas para guardar.");
      event.preventDefault();
      return;
    }

    this.indicacionesJsonTarget.value = JSON.stringify(this.indicaciones);
  }

  translateTipoIndicacion(value) {
    const indicaciones = {
      "farmacologica": "Farmacológica",
      "parenteral": "Parenteral",
      "enteral": "Enteral",
      "nutricion": "Nutrición"
    }
    return indicaciones[value] || "-"
  }

  translateVia(value) {
    const vias = {
      "endovenosa": "Endovenosa",
      "digestiva": "Digestiva",
      "intradermica": "Intradermica",
      "oftalmico": "Oftálmico",
      "inhalatoria": "Inhalatoria",
      "externa": "Externa",
      "intramuscular": "Intramuscular",
      "rectal": "Rectal",
      "vaginal": "Vaginal",
      "peridural": "Peridural",
      "nasogastrica": "Nasogastrica",
      "nasoyeyunal": "Nasoyeyunal",
      "orofaringia": "Orofaringia",
      "oral": "Oral",
      "subcutanea": "Subcutánea"
    }
    return vias[value] || "-"
  }

  translateTipo(value) {
    const tipos = {
      "plan_hidratacion": "Plan de Hidratación",
      "sedantes": "Sedantes",
      "plan_nutricion": "Plan de Nutrición"
    }
    return tipos[value] || "-"
  }

  translateVolumen(value) {
    const volumenes = {
      "ml_100": "100 ml",
      "ml_150": "150 ml",
      "ml_200": "200 ml",
      "ml_250": "250 ml",
      "ml_500": "500 ml",
      "ml_750": "750 ml",
      "ml_1000": "1000 ml",
      "ml_1500": "1500 ml",
      "ml_2000": "2000 ml",
      "ml_2500": "2500 ml",
      "ml_3000": "3000 ml"
    }
    return volumenes[value] || "-"
  }

  translateVelocidad(value) {
    const velocidades = {
      "goteo": "Goteo",
      "bomba": "Bomba",
      "a_pasar_en": "A pasar en"
    }
    return velocidades[value] || "-"
  }

  translateIntervalo(value) {
    const intervalos = {
      "cada_30": "30 Min",
      "cada_1": "1 HS",
      "cada_4": "4 HS",
      "cada_6": "6 HS",
      "cada_8": "8 HS",
      "cada_12": "12 HS",
      "cada_24": "24 HS",
      "unica": "Única vez"
    }
    return intervalos[value] || "-"
  }

  translateUnidad(value) {
    const unidades = {
      "ampolla": "Ampolla",
      "mg": "MG(Miligramos)",
      "ml": "ML(Mililitros)",
      "g": "G(Gramos)",
      "comprimido": "Comprimido",
      "mcg": "McG(Microgramo)",
      "puff": "PUFF",
      "gotas": "Gotas",
      "g_porciento": "G %"
    }
    return unidades[value] || "-"
  }

  translateUnidadAgregado(value) {
    const unidades_agregados = {
      "ampolla": "Ampolla",
      "mg": "MG(Miligramos)",
      "ml": "ML(Mililitros)",
      "g": "G(Gramos)",
      "comprimido": "Comprimido",
      "mcg": "McG(Microgramo)",
      "puff": "PUFF",
      "gotas": "Gotas",
      "g_porciento": "G %"
    }
    return unidades_agregados[value] || "-"
  }
}
